<p *ngIf="isSuccessVisible()">{{getSuccessMessage()}}</p>
<app-form-wizard *ngIf="isWizardVisible()" [formValues]="formValues" [template]="getContactFormWizard()" (actionButtonClick)="formWizardActionHandler($event)">
</app-form-wizard>